// @ts-nocheck

import config from '../../../config/app.config';
import { BasketOddsFromContexts } from '../../../constants/basket';
import { getLang } from '../../../i18n/l10n';
import { getVersion } from '../../../utils/common';

const { basketUrl } = config;

export default (stake, value, oddId) => {
  const lang = getLang();
  const bet = {
    A: Math.round(stake * 100),
    B: [{ BID: oddId, O: Math.round(value * 1000) }],
    CV: getVersion(),
    T: 1,
    locale: lang,
    CTX: {
      [BasketOddsFromContexts.IMMERSIVE]: true,
    },
  };
  const form = `bsm=${JSON.stringify(bet)}`;
  const url = basketUrl[lang];
  const method = 'post';
  const credentials = 'same-origin';

  return {
    url,
    method,
    credentials,
    body: form,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  };
};
